import { FC, useContext } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';

const ProjectPrice: FC = () => {
  const { estate } = useContext(ObjectPageContext);

  return (
    <span
      className="text-3xl lg:text-2xl xxxl:text-2xl font-lf text-blue700 lg:text-white leading-8"
      dangerouslySetInnerHTML={{
        __html:
          estate?.priceInfo?.priceMin
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
          ' - ' +
          estate?.priceInfo?.priceMax
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
          ' kr',
      }}
    ></span>
  );
};
export default ProjectPrice;
